<template>
  <div class="bg-F2F2F6 pt-12">
    <div class="lh-36 p-0-16 c-171A1D-40 font-28"> 学生 </div>

    <div
      class="bg-FFFFFF p-0-16 fb fb-main-start fb-cross-center h-64"
      v-for="(item, index) in list"
      @click="toBePerfect(item)"
      :key="index"
    >
      <div
        class="avatar mr-12 avator-image w-36 h-36"
        :class="item.imgClass"
      ></div>
      <div
        class="bb height-full fb fb-main-between fb-cross-center item-flex-1"
      >
        <div>
          <div class="c-171A1D font-34 fb fb-main-start fb-cross-center">
            <span class="mr-4 text-ellipsis max-w-180">{{ item.name }}</span>
            <span
              class="iconfont font-28"
              v-if="+item.gender"
              :style="{
                color: +item.gender === 1 ? '#006AFE' : '#FF4D94'
              }"
              >{{ +item.gender === 1 ? '&#xe685;' : '&#xe686;' }}</span
            >
          </div>
          <div class="font-28 c-171A1D-40 text-ellipsis max-w-180">{{
            item.deptName
          }}</div>
        </div>
        <div class="font-34 c-171A1D-40">
          <span class="mr-8" v-if="!item.identityStatus">待完善</span>
          <i class="iconfont">&#xe66b;</i>
        </div>
      </div>
    </div>

    <div class="lh-36 p-0-16 c-171A1D-40 font-28"> 家长 </div>
    <div
      class="bg-FFFFFF p-0-16 fb fb-main-start fb-cross-center h-64"
      v-for="(item, index) in guardianList"
      :key="`guardian_` + index"
      @click="toBePerfect(item, 'guardian')"
    >
      <div class="mr-12 guardian-avatar w-36 h-36 font-28">{{
        (item.name || {}).slice(0, 2)
      }}</div>
      <div
        class="bb height-full fb fb-main-between fb-cross-center item-flex-1"
      >
        <div>
          <div class="c-171A1D font-34 fb fb-main-start fb-cross-center">
            <span class="mr-4 text-ellipsis max-w-180">{{ item.name }}</span>
          </div>
          <div class="font-28 c-171A1D-40 text-ellipsis max-w-180">{{
            item.deptName
          }}</div>
        </div>
        <div class="font-34 c-171A1D-40">
          <span class="mr-8" v-if="!item.identityStatus">待完善</span>
          <i class="iconfont">&#xe66b;</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex'
import mixin from '@/mixin'
import { LEAVE_ROLE } from '@/utils/constUtils'
export default {
  name: 'PageEntryInformationGuardianDetail',
  mixins: [mixin],
  data() {
    return {
      list: [],
      guardianList: []
    }
  },
  computed: {
    ...mapGetters(['studentList'])
  },
  created() {
    this.getUserFamilyList()
  },
  methods: {
    toBePerfect(item, type) {
      this.$router.push({
        name: 'PageEntryInformationForm',
        query: {
          imgClass: item.imgClass || '',
          memberId: item.memberId,
          studentId: item.userDingId || '',
          campusId: type
            ? ''
            : (this.studentList.find(v => v.memberId === item.memberId) || {})
                .campusId || '',
          userType: item.imgClass ? 3 : 2
        }
      })
    },
    getUserFamilyList() {
      return new Promise((resolve, reject) => {
        API.getUserFamilyList({
          campusId: this.campusId,
          operUserRoleTypes: LEAVE_ROLE.guardian,
          memberId: this.$store.getters.orgUserId
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            res.studentList.map(item => {
              item.gender = item.sex
            })
            this.list = this.calculateStudentImage(res.studentList)
            this.guardianList = res.guardianList || []
          })
          .catch(err => {
            console.log(err)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.guardian-avatar {
  background: #006afe;
  text-align: center;
  line-height: 36px;
  color: #fff;
  border-radius: 50%;
}
</style>
